"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimerUnit = exports.TimerNumber = exports.TimerBlock = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _coreMixins = require("@vfuk/core-mixins");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TimerBlock = _styledComponents["default"].span.withConfig({
  displayName: "TimerBlockstyle__TimerBlock",
  componentId: "sc-1oitn0l-0"
})(function () {
  return (0, _styledComponents.css)(["display:inline-block;position:relative;"]);
});

exports.TimerBlock = TimerBlock;

var TimerNumber = _styledComponents["default"].span.withConfig({
  displayName: "TimerBlockstyle__TimerNumber",
  componentId: "sc-1oitn0l-1"
})(function (props) {
  return (0, _styledComponents.css)(["display:inline-block;", ";border-radius:", ";margin-right:2px;color:", ";background:", ";&:nth-child(2){margin-right:0;}", ""], (0, _coreMixins.advancedSpacing)('padding', [0, 1]), props.theme.border.radius[1], props.theme.color.monochrome1["default"], props.theme.color.monochrome5["default"], props.inverse && "\n    color: ".concat(props.theme.color.monochrome5["default"], ";\n    background: ").concat(props.theme.color.monochrome1["default"], ";\n  "));
});

exports.TimerNumber = TimerNumber;

var TimerUnit = _styledComponents["default"].div.withConfig({
  displayName: "TimerBlockstyle__TimerUnit",
  componentId: "sc-1oitn0l-2"
})(function (props) {
  return (0, _styledComponents.css)(["display:none;", ""], _coreMixins.respondTo.md((0, _styledComponents.css)(["display:block;position:absolute;text-align:center;top:100%;left:0;right:0;font-size:", ";font-weight:", ";"], props.theme.typography.paragraph[2].fontDesktop, props.theme.fontWeight[1])));
});

exports.TimerUnit = TimerUnit;
//# sourceMappingURL=TimerBlock.style.js.map